import React, { useEffect, useState } from 'react'
import { DeleteButton, Edit, SaveButton, TabbedForm, Toolbar, useDataProvider } from 'react-admin'
import Permission from '../../components/Permission'
import { PERMISSIONS } from '../../constants'
import { getChainId } from '../../lib'
import { ProductTab, RedeemTab, transformMoneyProduct } from './MoneyProductsForm'

const EditToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton />
    {/* DELETE no backend é soft delete (is_deleted = true) — daí o rótulo "Inativar",
        igual à bulk action da lista. */}
    <DeleteButton
      label="Inativar"
      mutationMode="pessimistic"
      redirect="/money-products"
      confirmTitle="Inativar produto em dinheiro"
      confirmContent="O produto deixa de aparecer no app e nos resgates. Deseja continuar?"
      sx={{ marginLeft: 'auto' }}
    />
  </Toolbar>
)

const edit = ({ ...props }) => {
  const dataProvider = useDataProvider()
  const [places, setPlaces] = useState<Array<{ id: string; name: string }>>([])

  useEffect(() => {
    dataProvider
      .getList(`chains/${getChainId()}/places`, { filter: {}, sort: { field: 'name', order: 'ASC' } })
      .then(({ data }) => setPlaces(data as Array<{ id: string; name: string }>))
  }, [])

  return (
    <Permission permission={PERMISSIONS.CREATE_PRODUCT}>
      <Edit {...props} title="Editar produto em dinheiro" mutationMode="pessimistic" transform={transformMoneyProduct}>
        <TabbedForm toolbar={<EditToolbar />} sanitizeEmptyValues>
          {ProductTab()}
          {RedeemTab({ places })}
        </TabbedForm>
      </Edit>
    </Permission>
  )
}

export default edit
